import {
  AccountSettingsInput,
  Operation,
} from '../../../__generated__/globalTypes'

import {
  UserSettingsFragment,
  userSettingsFragmentString,
} from '../../fragments/__generated__/UserSettingsFragment'

import updateAccountSettingsRawString from '../UpdateAccountSettings.graphql'

const updateAccountSettingsString = [
  updateAccountSettingsRawString,
  userSettingsFragmentString,
].join('\n\n')

export type UpdateAccountSettingsData = {
  updateAccountSettings: {
    settings: UserSettingsFragment
  }
}

export type UpdateAccountSettingsVariables = {
  settings: AccountSettingsInput
}

export type UpdateAccountSettings = Operation<
  UpdateAccountSettingsData,
  UpdateAccountSettingsVariables
>

export const UpdateAccountSettings = ({
  settings,
}: UpdateAccountSettingsVariables): UpdateAccountSettings => ({
  query: updateAccountSettingsString,
  variables: {
    settings: AccountSettingsInput(settings),
  },
})
